import {
  PHOTOS_TRAY_SORT_DEFAULT,
  type PhotosTraySort,
  isPhotosTraySort,
} from '@/lib/photos/sort-tray-photos'

/** Persist the Photos tray Sort control (survives refresh). Cleared on logout via `clearAuth`. */
export const PHOTOS_TRAY_SORT_STORAGE_KEY = 'photos-tray-sort.v1'

export function readStoredPhotosTraySort(): PhotosTraySort {
  if (typeof window === 'undefined') return PHOTOS_TRAY_SORT_DEFAULT

  try {
    const raw = localStorage.getItem(PHOTOS_TRAY_SORT_STORAGE_KEY)

    if (raw == null || raw === '') return PHOTOS_TRAY_SORT_DEFAULT

    const value = JSON.parse(raw) as unknown

    return isPhotosTraySort(value) ? value : PHOTOS_TRAY_SORT_DEFAULT
  } catch {
    return PHOTOS_TRAY_SORT_DEFAULT
  }
}

export function writeStoredPhotosTraySort(sort: PhotosTraySort): void {
  if (typeof window === 'undefined') return

  try {
    localStorage.setItem(PHOTOS_TRAY_SORT_STORAGE_KEY, JSON.stringify(sort))
  } catch {
    // Quota / private mode — ignore.
  }
}

export function clearStoredPhotosTraySort(): void {
  if (typeof window === 'undefined') return

  try {
    localStorage.removeItem(PHOTOS_TRAY_SORT_STORAGE_KEY)
  } catch {
    // ignore
  }
}
